import PropTypes from 'prop-types';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      For your virtual appointment we&apos;ll call you on the number you&apos;ve provided. It will
      also be useful to have access to <a href="#">our website</a> so we can view and talk through
      the products together
    </li>
    <li>
      We&apos;ll spend time understanding your needs in this appointment as well as brands or
      products you&apos;re interested in
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
